import { render, staticRenderFns } from "./BaseDataTablePagination.vue?vue&type=template&id=7fcfdf2e"
import script from "./BaseDataTablePagination.vue?vue&type=script&lang=js"
export * from "./BaseDataTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports